/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type Device, DeviceSchema } from './device'

/* TypeScript */
export type CTALink = {
  link: ContentLink
  label: string
  hiddenDevices?: Maybe<Device[]>
}

/* Schemas */
export const CTALinkSchema = z.object({
  link: ContentLinkSchema,
  label: z.string(),
  hiddenDevices: z.nullish(z.array(DeviceSchema)),
})

/* Schemas validation */
type TestCTALink = ExpectTrue<Equal<CTALink, z.infer<typeof CTALinkSchema>>>
